"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.uncontrollable = exports.useUncontrolled = void 0;

var _hook = _interopRequireDefault(require("./hook.js"));

exports.useUncontrolled = _hook.default;

var _uncontrollable = _interopRequireDefault(require("./uncontrollable.js"));

exports.uncontrollable = _uncontrollable.default;


//////////////////
// WEBPACK FOOTER
// ./~/uncontrollable/cjs/index.js
// module id = 41
// module chunks = 0